import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const ResizablePanelTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      sidebarBg: theme.color.grid['select-inherited-stripe'],
      dividerBg: theme.color.surface[2],
      mainBg: theme.color.surface[4],
      contentText: theme.color.text.core['-emphasis'],
    },
  ]),
);
